import axios from "axios";
import { ERROR_CODES } from "@upsolve/shared";

export default async function validateEmailAddress(email) {
  return axios.post(`${UPSOLVE_API_URL}/v1/validators/email`, { email }).then(({ data }) => {
    const { valid, used } = data;
    let error = null;
    if (!valid) {
      error = ERROR_CODES.INVALID_EMAIL;
    } else if (used) {
      error = ERROR_CODES.FILER_EXISTS;
    }
    return {
      isValid: error == null,
      error,
    };
  });
}
